import { FACETS_FIELD_KEY } from '@tcp/core/src/services/abstractors/productListing/productListing.utils';
import has from 'lodash/has';
import { getCurrentFeatureBrandAttribute } from '../../../../SearchDetail/container/SearchDetail.util';

const ListFilterNamesGreaterThanOne = (filtersMaps) => {
  return Object.entries(filtersMaps)
    .map((filterName) => {
      return filterName[1]?.length >= 1 ? filterName[0] : null;
    })
    .filter((x) => x !== null);
};

const AddOrRemovePriceFilterPill = (filtersMaps) => {
  const tmp = JSON.parse(JSON.stringify(filtersMaps));
  const unbxdPriceRangeUFilter = tmp?.unbxd_price_range_uFilter;
  if (
    unbxdPriceRangeUFilter?.length === 0 &&
    filtersMaps?.newPriceRange?.min !== filtersMaps?.newPriceRange?.max
  ) {
    unbxdPriceRangeUFilter[0] = 1;
  }
  return ListFilterNamesGreaterThanOne(tmp);
};

const priceAddRemoveFn = (FormValuesLocal) => {
  if (
    Object.prototype.hasOwnProperty.call(FormValuesLocal, 'min_offer_price') &&
    FormValuesLocal.min_offer_price.length > 0
  ) {
    return { ...FormValuesLocal, unbxd_price_range_uFilter: FormValuesLocal.min_offer_price };
  }
  return FormValuesLocal;
};

const assignFitToSize = (UpdatedFormValuesLocal) => {
  if (
    Object.prototype.hasOwnProperty.call(UpdatedFormValuesLocal, 'v_tcpfit_unbxd_uFilter') &&
    UpdatedFormValuesLocal.v_tcpfit_unbxd_uFilter.length > 0
  ) {
    if (Object.prototype.hasOwnProperty.call(UpdatedFormValuesLocal, 'v_tcpsize_uFilter')) {
      return {
        ...UpdatedFormValuesLocal,
        v_tcpsize_uFilter: [
          ...UpdatedFormValuesLocal?.v_tcpsize_uFilter,
          UpdatedFormValuesLocal?.v_tcpfit_unbxd_uFilter,
        ],
      };
    }
    return {
      ...UpdatedFormValuesLocal,
      v_tcpsize_uFilter: [UpdatedFormValuesLocal?.v_tcpfit_unbxd_uFilter],
    };
  }
  return UpdatedFormValuesLocal;
};

const removeNullValuesFromObject = (UpdatedFormValuesLocal) => {
  return Object.entries(UpdatedFormValuesLocal)
    .map((formvalue) => {
      return formvalue[1].length > 0 ? formvalue[0] : null;
    })
    .filter((x) => x !== null);
};

const checkForSizeFitColor = (filterName, initialValues, appliedFiltersLocal) => {
  if (
    filterName === 'v_clothingsize_uFilter' ||
    filterName === 'v_tcpfit_unbxd_uFilter' ||
    filterName === 'TCPColor_uFilter'
  ) {
    return (
      appliedFiltersLocal.includes(filterName) ||
      (has(initialValues, filterName) && initialValues[filterName].length > 0)
    );
  }
  return appliedFiltersLocal.includes(filterName) || has(initialValues, filterName);
};

const finalFilterPillsList = (
  updatedFilterNamesListGreaterThanOne,
  filterUnbxdNameMaplist,
  FormValuesLocal,
  isSizeGroupFilterEnabled,
  initialValues,
  isFeatureBrandView
) => {
  const UpdatedFormValuesLocal = priceAddRemoveFn(FormValuesLocal);
  const FitToSizeFilters = assignFitToSize(UpdatedFormValuesLocal);
  const appliedFiltersLocal = removeNullValuesFromObject(FitToSizeFilters);
  const removalList = ['Fit', 'Category'];
  return (
    filterUnbxdNameMaplist &&
    updatedFilterNamesListGreaterThanOne
      .filter((filterName) => {
        if (isSizeGroupFilterEnabled && filterName?.toLowerCase() === FACETS_FIELD_KEY.size) {
          return false;
        }
        if (
          !isSizeGroupFilterEnabled &&
          (filterName?.toLowerCase() === FACETS_FIELD_KEY.clothingsize ||
            filterName?.toLowerCase() === FACETS_FIELD_KEY.shoessize ||
            filterName?.toLowerCase() === FACETS_FIELD_KEY.accessoriessize)
        ) {
          return false;
        }
        if (
          isFeatureBrandView &&
          filterName?.toLowerCase() ===
            getCurrentFeatureBrandAttribute(filterUnbxdNameMaplist).toLowerCase()
        ) {
          return false;
        }
        return true;
      })
      .map((filterName) => {
        return Object.keys(filterUnbxdNameMaplist).includes(filterName)
          ? [
              filterUnbxdNameMaplist[filterName],
              checkForSizeFitColor(filterName, initialValues, appliedFiltersLocal),
            ]
          : null;
      })
      .filter((x) => x !== null)
      .filter((x) => !removalList.includes(x[0]))
  );
};

const setFilterOption = (e, lblFilter, filterUnbxdNameMaplist) => {
  return e.target.innerText.toUpperCase().includes(lblFilter)
    ? filterUnbxdNameMaplist.TCPColor_uFilter
    : e.target.innerText;
};

const FILTER_DISPLAY_NAME_MAP = {
  TCPStyleQTYUS_uFilter: 'Multipacks',
  age_group_uFilter: 'Age Group',
};

const facetNameChange = (filterUnbxdNameMaplist) => {
  return {
    ...filterUnbxdNameMaplist,
    TCPStyleQTYUS_uFilter: FILTER_DISPLAY_NAME_MAP.TCPStyleQTYUS_uFilter,
    age_group_uFilter: FILTER_DISPLAY_NAME_MAP.age_group_uFilter,
  };
};

const sortValueCheck = (formValues) => {
  return (
    formValues?.sort?.length !== 0 && formValues !== undefined && Object.keys(formValues).length > 0
  );
};

export {
  ListFilterNamesGreaterThanOne,
  AddOrRemovePriceFilterPill,
  finalFilterPillsList,
  removeNullValuesFromObject,
  setFilterOption,
  facetNameChange,
  priceAddRemoveFn,
  assignFitToSize,
  sortValueCheck,
};
